var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowbarup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow bar up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0619 17.562C34.2016 17.4227 34.3125 17.2571 34.3881 17.0749C34.4637 16.8927 34.5026 16.6973 34.5026 16.5C34.5026 16.3027 34.4637 16.1073 34.3881 15.9251C34.3125 15.7429 34.2016 15.5773 34.0619 15.438L25.0619 6.438C24.9226 6.29831 24.7571 6.18748 24.5748 6.11186C24.3926 6.03624 24.1972 5.99731 23.9999 5.99731C23.8026 5.99731 23.6073 6.03624 23.425 6.11186C23.2428 6.18748 23.0773 6.29831 22.9379 6.438L13.9379 15.438C13.6563 15.7197 13.498 16.1017 13.498 16.5C13.498 16.8983 13.6563 17.2803 13.9379 17.562C14.2196 17.8437 14.6016 18.0019 14.9999 18.0019C15.3983 18.0019 15.7803 17.8437 16.0619 17.562L23.9999 9.621L31.9379 17.562C32.0773 17.7017 32.2428 17.8125 32.425 17.8881C32.6073 17.9638 32.8026 18.0027 32.9999 18.0027C33.1972 18.0027 33.3926 17.9638 33.5748 17.8881C33.7571 17.8125 33.9226 17.7017 34.0619 17.562Z",
    fill: "#007BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 30C24.3978 30 24.7793 29.842 25.0606 29.5607C25.3419 29.2794 25.5 28.8978 25.5 28.5V9C25.5 8.60218 25.3419 8.22064 25.0606 7.93934C24.7793 7.65804 24.3978 7.5 24 7.5C23.6022 7.5 23.2206 7.65804 22.9393 7.93934C22.658 8.22064 22.5 8.60218 22.5 9V28.5C22.5 28.8978 22.658 29.2794 22.9393 29.5607C23.2206 29.842 23.6022 30 24 30ZM9.59998 34.8C9.59998 34.14 10.14 33.6 10.8 33.6H37.2C37.5182 33.6 37.8235 33.7264 38.0485 33.9515C38.2735 34.1765 38.4 34.4817 38.4 34.8C38.4 35.1183 38.2735 35.4235 38.0485 35.6485C37.8235 35.8736 37.5182 36 37.2 36H10.8C10.4817 36 10.1765 35.8736 9.95145 35.6485C9.7264 35.4235 9.59998 35.1183 9.59998 34.8Z",
    fill: "#007BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowbarup);
export default __webpack_public_path__ + "static/media/Arrow bar up.1952064a87806db8ea7f65fa49d5445c.svg";
export { ForwardRef as ReactComponent };